import styled from 'styled-components';
import { Colors } from '../constants/colors';
import { Fonts } from '../constants/fonts';

export const Link = styled.button`
  background: none;
  border: none;
  color: ${Colors.primary};
  padding: 0;
  font-family: ${Fonts.base};
  font-size: 16px;
`;
